import { InjectionToken } from '@angular/core'

export type SupportEnvironment = {
  key: string
  label: string
  // Empty for the environment serving this app, whose requests stay relative and same-origin.
  origin: string
}

export const SELF_ENVIRONMENT: SupportEnvironment = { key: 'self', label: '', origin: '' }

export function isSelfEnvironment(environment: SupportEnvironment): boolean {
  return environment.origin === ''
}

/**
 * Every support screen reads from a list of environments rather than from "the" backend, so the
 * single-environment case is the same code path with a one-entry list. The default keeps the main
 * UI and its tests wiring-free; Atlas overrides it with the customer environments.
 */
export const SUPPORT_ENVIRONMENTS = new InjectionToken<SupportEnvironment[]>('SUPPORT_ENVIRONMENTS', {
  providedIn: 'root',
  factory: () => [SELF_ENVIRONMENT],
})
